<div class="container text-left">
  <div class="container">
    <form [formGroup]="form">
      <h3 class="subtitulo">Processo</h3>
      <div class="form-row">
        <div class="col-7">
          <app-nro-processo-input formControlName="nroProcesso" tipoOrdem="ACAO"></app-nro-processo-input>
        </div>
        <div class="d-flex justify-content-center align-items-center col-auto ">
          <button
            mat-button
            [disabled]="!nroProcesso.valid"
            class="btn btn-branco"
            (click)="buscarOrdem()"
          >
            Verificar
          </button>
        </div>
      </div>
    </form>
    <div *ngIf="consultaAcaoRealizada">
      <div *ngIf="!existeAcao">
        <app-incluir-acao-form [tokenIam]="tokenIam" [nroProcesso]="nroProcesso.value"></app-incluir-acao-form>
      </div>
      <div *ngIf="existeAcao">
        <app-atualizar-acao-form [tokenIam]="tokenIam" [nroProcesso]="nroProcesso.value" [ordem]="ordem"></app-atualizar-acao-form>
      </div>
    </div>
  </div>
</div>
